import {
  useGetService,
  type UseGetServiceOptions,
} from "@libs/service-providers/api-service-provider";

import { DASHBOARD_SUMMARY_URL } from "./apiEndpoints";
import type { SummaryItem } from "./types";

type UseGetSummaryOptions = Omit<UseGetServiceOptions<SummaryItem[]>, "route" | "queryKey">;

export const useGetSummary = (options?: UseGetSummaryOptions) =>
  useGetService<SummaryItem[]>({
    route: DASHBOARD_SUMMARY_URL,
    queryKey: ["dq-dashboard", "summary"],
    retry: false,
    ...(options ?? {}),
  });
